import './cookieconsent.umd.js';


// Enable dark mode
document.documentElement.classList.add('cc--light-funky');

async function isGDPR() {

    if (getCookie('cc_cookie') !== '') {
        return false;
    }
    var isGDPR = false;
    await fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
        const countryCode = data.detected_values.country.handle;
        const gdprCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK']; 
        isGDPR = gdprCountries.includes(countryCode);
    })
    .catch(error => {
        console.error(error);
    });
    if(isGDPR){
        setCookie('cc_isGDPR', 'True', 1);
    }
    else{
        setCookie('cc_isGDPR', 'False', 1);
    }
    return isGDPR;
}

function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
let isGDPRValue = getCookie('cc_isGDPR');
if( isGDPRValue === ''){
    isGDPRValue = await isGDPR();
}
else
{
    if(isGDPRValue === 'True')
    {
        isGDPRValue = true;
    }
    else
    {
        isGDPRValue = false;
    }
}
if(!isGDPRValue){
    CookieConsent.run({
        mode: 'opt-out',
        guiOptions: {
            consentModal: {
                layout: "bar inline",
                position: "bottom",
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: "bar wide",
                position: "left",
                equalWeightButtons: true,
                flipButtons: false
            }
        },
        categories: {
            necessary: {
                readOnly: true
            },
            functionality: {
                enabled: true
            },
            analytics: {
                enabled: true
            },
            marketing: {
                enabled: true
            }
        },
        language: {
            default: "en",
            autoDetect: "browser",
            translations: {
                en: {
                    consentModal: {
                        description: `We use cookies on this site to optimize its functionality and give you a personalized experience. By continuing to use this site, you agree to the terms of our Cookie Policy.
                        <u><a href="/pages/privacy-policy/">Details</a></u>`,
                        showPreferencesBtn: isGDPRValue ? "<u>Settings</u>" : "",
                        acceptAllBtn: "OK",
                    },
                    preferencesModal: {
                        title: "Privacy Preference Center",
                        acceptAllBtn: "Accept all",
                        acceptNecessaryBtn: "Reject Additional Cookies",
                        savePreferencesBtn: "Save preferences",
                        closeIconLabel: "Close modal",
                        serviceCounterLabel: "Service|Services",
                        sections: [
                            {
                                title: "About Your Privacy",
                                description: `When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. 
                                This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. 
                                The information does not usually directly identify you, but it can give you a more personalized web experience. 
                                Because we respect your right to privacy, you can choose not to allow some types of cookies. 
                                Click on the different category headings to find out more and change our default settings. 
                                However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.<br/>
                                <a href="/pages/privacy-policy/">Privacy Policy</a>`
                            },
                            {
                                title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                                description: `These cookies are necessary for the website to function and cannot be switched off in our systems. 
                                They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, 
                                logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. 
                                These cookies do not store any personally identifiable information.<br/>
                                <a href="/pages/privacy-policy/">Privacy Policy</a>`,
                                linkedCategory: "necessary",
                                cookieTable: {
                                    caption: 'List of cookies',
                                    headers: {
                                        name: 'Name',
                                        host: 'Host',
                                        duration: 'Duration',
                                        type: 'Type',
                                        category: 'Category',
                                        description: 'Description'
                                        
                                    },
                                    body: [
                                        {
                                            name: 'locale',
                                            host: 'swimoutlet.com',
                                            duration: 'Session',
                                            type: 'First Party',
                                            category: 'Strictly Necessary Cookies',
                                            description: 'This cookie is essential to provide the user the service it requested in the language they prefer.'
                                        },
                                        {
                                            name: 'p20t',
                                            host: 'swimoutlet.com',
                                            duration: 'Session',
                                            type: 'First Party',
                                            category: 'Strictly Necessary Cookies',
                                            description: 'This cookie is an essential cookie which allows authentication of users.'
                                        },
                                        {
                                            name: 'BNC_FV_KEY',
                                            host: 'swimoutlet.com',
                                            duration: '1 Day',
                                            type: 'First Party',
                                            category: 'Strictly Necessary Cookies',
                                            description: 'This cookie is an essential cookie that allows users to access the watcher link feature, which means that they can view the operation status of miners and calculate hash rates in read-only mode without having to log into an account.'
                                        },
                                        {
                                            name: '_cfuvid',
                                            host: 'zoominfo.com',
                                            duration: 'Session',
                                            type: 'Third Party',
                                            category: 'Strictly Necessary Cookies',
                                            description: 'This is a cloudflare cookie which is only used to allow the Cloudflare WAF to distinguish individual users who share the same IP address. Without this cookie, users from the same IP will be grouped together and most likely not given access to this site.'
                                        },
                                    ]
                                }
                            },
                            {
                                title: "Functionality Cookies",
                                description: `These cookies enable the website to provide enhanced functionality and personalisation. 
                                They may be set by us or by third party providers whose services we have added to our pages. 
                                If you do not allow these cookies then some or all of these services may not function properly.<br/>
                                <a href="/pages/privacy-policy/">Privacy Policy</a>`,
                                linkedCategory: "functionality",
                                cookieTable: {
                                    caption: 'List of cookies',
                                    headers: {
                                        name: 'Name',
                                        host: 'Host',
                                        duration: 'Duration',
                                        type: 'Type',
                                        category: 'Category',
                                        description: 'Description'
                                        
                                    },
                                    body: [
                                        {
                                            name: 'fiat-user-save-currency',
                                            host: 'swimoutlet.com',
                                            duration: 'Session',
                                            type: 'First Party',
                                            category: 'Functional Cookies',
                                            description: 'This cookie is a functional cookie which allows the site to remember the users currency preferences.to view the operation status of miners and calculate hash rates in read-only mode without having to log in to your account.'
                                        },
                                        {
                                            name: 'userPreferredCurrency',
                                            host: 'swimoutlet.com',
                                            duration: '365 Day',
                                            type: 'First Party',
                                            category: 'Functional Cookies',
                                            description: 'This cookie is essential to enable users to transact in the website and access Binance services, as it reflect the currency preferences.'
                                        },
                                        {
                                            name: '__cfruid',
                                            host: 'medium.com',
                                            duration: 'Session',
                                            type: 'Third Party',
                                            category: 'Functional Cookies',
                                            description: 'Cookie associated with sites using CloudFlare, used to identify trusted web traffic.'
                                        }
                                    ]
                                }
                            },
                            {
                                title: "Targeting Cookies",
                                description: `Targeting cookies may be set through our site by ourselves and our advertising partners. 
                                First parties and third parties will use them to build a profile of your interests based on the browsing information 
                                they collect from you, which includes uniquely identifying your browser and terminal equipment. 
                                If you do not allow these cookies you will still see basic advertising on your browser that is generic 
                                and not based on your interests<br/>
                                <a href="/pages/privacy-policy/">Privacy Policy</a>`,
                                linkedCategory: "marketing",
                                cookieTable: {
                                    caption: 'List of cookies',
                                    headers: {
                                        name: 'Name',
                                        host: 'Host',
                                        duration: 'Duration',
                                        type: 'Type',
                                        category: 'Category',
                                        description: 'Description'
                                        
                                    },
                                    body: [
                                        {
                                            name: 'campaign',
                                            host: 'swimoutlet.com',
                                            duration: 'Session',
                                            type: 'First Party',
                                            category: 'Targeting Cookies',
                                            description: 'Analytics and research.'
                                        },
                                        {
                                            name: 'source',
                                            host: 'swimoutlet.com',
                                            duration: 'Session',
                                            type: 'First Party',
                                            category: 'Targeting Cookies',
                                            description: 'This cookie is managed to perform analytics and research.'
                                        },
                                        {
                                            name: '_fbmk',
                                            host: 'www.facebook.com',
                                            duration: 'Session',
                                            type: 'Third Party',
                                            category: 'Targeting Cookies',
                                            description: `This domain is owned by Facebook, which is the world's largest social networking service. As a third party host provider, it mostly collects data on the interests of users via widgets such as the 'Like' button found on many websites. This is used to serve targeted advertising to its users when logged into its services. In 2014 it also started serving up behaviourally targeted advertising on other websites, similar to most dedicated online marketing companies.`
                                        },
                                        {
                                            name: 'CONSENT',
                                            host: 'google.com',
                                            duration: 'Session',
                                            type: 'Third Party',
                                            category: 'Targeting Cookies',
                                            description: `This domain is owned by Google Inc. Although Google is primarily known as a search engine, the company provides a diverse range of products and services. Its main source of revenue however is advertising. Google tracks users extensively both through its own products and sites, and the numerous technologies embedded into many millions of websites around the world. It uses the data gathered from most of these services to profile the interests of web users and sell advertising space to organisations based on such interest profiles as well as aligning adverts to the content on the pages where its customer's adverts appear.`
                                        },
                                        {
                                            name: 'VISITOR_PRIVACY_METADATA',
                                            host: 'youtube.com',
                                            duration: '179 Days',
                                            type: 'Third Party',
                                            category: 'Targeting Cookies',
                                            description: `YouTube is a Google owned platform for hosting and sharing videos. YouTube collects user data through videos embedded in websites, which is aggregated with profile data from other Google services in order to display targeted advertising to web visitors across a broad range of their own and other websites.`
                                        },
                                        {
                                            name: 'MUID',
                                            host: 'bing.com',
                                            duration: '389 Days',
                                            type: 'Third Party',
                                            category: 'Targeting Cookies',
                                            description: `This domain is owned by Microsoft - it is the site for the search engine Bing.`
                                        }
                                    ]
                                }
                            },
                            {
                                title: "Performance Cookies",
                                description: `These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. 
                                They help us to know which pages are the most and least popular and see how visitors move around the site. 
                                All information these cookies collect is aggregated and therefore anonymous. 
                                If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.<br/>
                                <a href="/pages/privacy-policy/">Privacy Policy</a>`,
                                linkedCategory: "analytics",
                                cookieTable: {
                                    caption: 'List of cookies',
                                    headers: {
                                        name: 'Name',
                                        host: 'Host',
                                        duration: 'Duration',
                                        type: 'Type',
                                        category: 'Category',
                                        description: 'Description'
                                        
                                    },
                                    body: [
                                        {
                                            name: '_ga_xxxxxxxxxx',
                                            host: 'swimoutlet.com',
                                            duration: '729 Days',
                                            type: 'First Party',
                                            category: 'Performance Cookies',
                                            description: `Used by Google Analytics to distinguish users and sessions.`
                                        },
                                        {
                                            name: '_gclxxxx',
                                            host: 'swimoutlet.com',
                                            duration: '729 Days',
                                            type: 'First Party',
                                            category: 'Performance Cookies',
                                            description: `Google conversion tracking cookie.`
                                        },
                                        {
                                            name: '_ga',
                                            host: 'swimoutlet.com',
                                            duration: 'A few seconds',
                                            type: 'First Party',
                                            category: 'Performance Cookies',
                                            description: `This cookie is a functional cookie which tracks which is the intro video completion status.`
                                        }
                                    ]
                                }
                            },
                            {
                                title: "More information",
                                description: "For any query in relation to my policy on cookies and your choices, please <a class=\"cc__link\" href=\"/pages/privacy-policy/\">contact me</a>."
                            }
                        ]
                    }
                }
            }
        },
        disablePageInteraction: false
    });
    if(!isGDPRValue){
        function delayedAcceptCookies() {
            document.body.removeEventListener('click', delayedAcceptCookies);
            window.removeEventListener('scroll', delayedAcceptCookies);
            document.body.removeEventListener('keypress', delayedAcceptCookies);
            clearTimeout(delayedAcceptCookies.timeout);
            delayedAcceptCookies.timeout = setTimeout(acceptCookies, 2000);
        }
        document.body.addEventListener('click', delayedAcceptCookies);
        window.addEventListener('scroll', delayedAcceptCookies);
        document.body.addEventListener('keypress', delayedAcceptCookies);
    
        function acceptCookies() {
            var button = document.querySelector('.cm__btn[data-role="all"]');
            if (button) {
                button.click();
            }
        } 
    }    
}
